export default {
    login: {
        new: {
            title: "New to our store",
            description: "Access our store as a guest by entering the information below.",
            form: {
                field1: "FedEx Ground ID",
                field2: "Contract Number"
            }
        },
        existing: {
            title: "Already a customer",
            description: "Welcome back. Please sign in with your store credentials.",
            form: {
                field1: "Email Address",
                field2: "Password"
            }
        },
        links: {
            forgotPassword: "Forgot Password?",
            assistance: "Need assistance?",
            privacy: "Privacy Statement"
        },
        or: "OR",
        btn: "Login"
    },
    passwordRecovery: {
        title: "Password Recovery",
        description: "To reset your password, verify the email address you use to sign in",
        form: {
            field1: "Email Address"
        },
        success: {
            title: "Password Reset Email Sent",
            description: "Please check your email to reset your password."
        },
        btn: "Send",
        back: "Go Back To Login"
    },
    passwordReset: {
        title: "Password Recovery",
        description: "Enter and confirm your new password in the form below",
        form: {
            field1: "New Password",
            field2: "Confirm New Password"
        },
        success: {
            title: "Your password has been changed"
        },
        btn: "Recover",
        back: "Go Back To Login"
    },
    navMenu: {
        logout: "Logout",
        profile: "My Account"
    },
    home: {
        tabName: "Home",
        title: "Welcome to the Velocitor Store",
        cspBlock: {
            description: "Enjoy a quick and easy shopping experience by bundling the necessary equipment and services into kits.",
            shopKitsBtn: "Shop Kits",
            buildAKitBtn: "Build a Kit"
        },
        vTrackBlock: {
            header: "V-Track Fleet Solution",
            description: "Learn more about Velocitor's Mobile Fleet Management and Technology Solution."
        },
        devicesBlock: {
            description: "What device is right for you?",
            compare: "Compare Devices"
        },
        categories: {
            devices: {
                description: "We stock Panasonic and Zebra"
            },
            zebra: {
                description: "We carry a full line of Zebra accessories"
            },
            panasonic: {
                description: "We carry a full line of Panasonic accessories"
            }
        }
    },
    devices: {
        title: "Devices",
        wizard: {
            steps: {
                one: {
                    title: "Devices",
                    message: "Please choose a device."
                },
                two: {
                    title: "Wireless"
                },
                three: {
                    title: "Cart"
                }
            }
        }
    },
    kits: {
        title: "Kits",
        wizard: {
            steps: {
                one: {
                    title: "Kits",
                    message: "Please choose a device to start building your kit."
                },
                two: {
                    title: "Wireless"
                },
                three: {
                    title: "Cart"
                }
            }
        }
    },
    buildAKit: {
        title: "Build a Kit",
        kitPricingSummary: {
            title: "Kit Pricing Summary",
            devices: "Devices",
            dataPlans: "Carrier Cellular Plans",
            chargingAccessories: "Charging Accessories",
            optionalAccessories: "Optional Accessories",
            totalDue: "Total Due",
            numberOfKits: "Number of Kits"
        },
        wizard: {
            steps: {
                one: {
                    title: "Select Device",
                    message: "Please choose a device to start building your kit."
                },
                two: {
                    title: "Select Carrier"
                },
                three: {
                    title: "Select Charging Accessories"
                },
                four: {
                    title: "Select Optional Accessories"
                }
            }
        },
        chargingAccessories: {
            message: "We offer Vehicle and Home/Office charging options. Please choose one of the charging options below."
        },
        optionalAccessories: {
            message: "These accessories are not required for your kit, but provide added convenience and protection."
        },
        kitProduct: {
            name: "%{name} Kit",
            title: "%{name} includes:",
            panasonicN1: {
                li1: "Panasonic N1 Mobile Computer with Battery",
                li2: "Free Spare Battery and Hand Strap",
                li3: "* Staging and Kitting Services as well as 3 Year Advance Exchange Required"
                // li4: "Staging and Kitting"
            },
            zebraTc77: {
                li1: "TC-77 Zebra Mobile Computer with Battery",
                li2: "Free Spare Battery and Hand Strap",
                li3: "* Staging and Kitting Services as well as 3 Year Advance Exchange Required"
                // li4: "Staging and Kitting"
            }
        }
    },
    accessories: {
        accessories: "Accessories",
        title: "%{name} Accesories"
    },
    relatedProducts: {
        title: "Related Products"
    },
    deviceComparison: {
        title: "Device Comparison"
    },
    dataPlans: {
        title: "Would you like to add a data plan?",
        message: "Based on FXG’s assessment of the FORGE App’s average data consumption rates, a 3 GB per month cellular plan is the minimum requirement. As technology continues to advance and new features and functions are deployed, data consumption will continue to grow. The updated data plans are intended to support all device updates via cellular connectivity. Wi-Fi network connection will no longer be needed to update the FORGE app or perform any other device updates.",
        canadaOnly: "Canada Only",
        overage1: "Overage: $.12 per MB",
        overage2: "Overage: $11.53 per GB",
        tooltip: "Please Make a Data Plan Selection",
        select: "Select Plan",
        select2: "Select a Monthly Data Plan",
        modalTitle: "No Data Plan",
        modalText: "You are selecting not to have a data plan associated with your device. Do you wish to continue?",
        modalCancel: "Cancel",
        modalContinue: "Continue"
    },
    orderSummary: {
        title: "Order Summary"
    },
    cart: {
        title: "Cart",
        cartEmpty: "Your cart is empty!",
        continueShopping: "Continue Shopping",
        printCart: "Print Cart",
        clearCart: "Clear Cart",
        panels: {
            kitsDevices: "Kits / Devices",
            accessories: "Accessories",
            services: "Recurring Monthly Services",
            accessoriesMessage: "Looking for multi-device, storage and other useful accessories? Go to the Accessories Menu above or click one of the links below to add additional items directly to your cart."
        },
        totalDue: "Total Amount Due",
        shippingTaxes: "Shipping and Taxes will be calculated at Checkout",
        payment: {
            title: "How do you want to pay?",
            customerAlert: {
                station: "Station",
                employeeId: "Employee ID",
                purchaseEligibilityDate: "Purchase Eligibility Date",
                onTheRoadEligibilityDate: "On The Road Eligibility Date",
                customMessage: "Based on the records received from FedEx Ground, your station has not yet been scheduled for activation. Additional waves will begin in January",
                guestMessage: "To save items added to your cart please",
                createAccount: "create an account",
                saveItemsToCart: "We will save the items in your shopping cart for you. Please return to the store on or after your eligibility date to complete your order.",
                needAssistance1: "If you have any questions or need assistance please",
                needAssistance2: "contact",
                needAssistance3: "Velocitor Support",
                thankYou: "Thank you."
            },
            options: {
                payInFull: {
                    title: "Pay in full",
                    desc1: "One-time payment",
                    desc2: "Recurring Monthly Services",
                    note: "Click here if you would like to pay for your order in full using a Bank Draft or a Credit/Debit Card"
                },
                lease: {
                    title: "Lease",
                    desc1: "Estimated Monthly Payment (36 Month Lease)",
                    desc2: "Recurring Monthly Services",
                    note: "Click here if you would like to apply for a lease toward the purchase of eligible items on your order"
                }
            }
        },
        rentalMessage: "Leasing not available with rental item in cart"
    },
    leaseApplication: {
        title: "Submit Your Application for a Lease",
        wizard: {
            steps: {
                zero: {
                    title: "Create Account"
                },
                one: {
                    title: "Leasing Application"
                }
            }
        },
        paragraphs: {
            one: {
                header: "Submit Lease Application",
                description1: "Click",
                description2: "Apply for a Lease",
                description3: "below to process your application for a lease. Follow the instructions on the DocuSign Form to complete and submit your lease application."
            },
            two: {
                header: "If You are Approved",
                description: "If you are approved for the lease, you will receive an email with your personal Approval Code. When you receive your Approval code, return to the Velocitor Store, open your shopping Cart, click the Lease option and enter your Approval Code to process your order."
            },
            three: {
                header: "If You are Denied",
                description: "If you are initially denied for the lease, don't worry! There may be additional information you can provide to gain approval or other financing options may be available. A Velocitor representative will contact you to explore how best to complete your purchase."
            }
        },
        applyBtn: "APPLY FOR A U.S. LEASE",
        applyBtnCan: "APPLY FOR A CANADIAN LEASE"
    },
    checkout: {
        title: "Checkout",
        summary: {
            payInFull: {
                subTotal: "Cart Subtotal",
                taxes: "Taxes",
                fee: "CC Processing Fee",
                total: "Order Total",
                taxStatement: "Applicable taxes will be charged upon invoice"
            },
            recurring: {
                subTotal: "Rec. Monthly Services Subtotal",
                total: "Recurring Monthly Services"
            },
            lease: {
                message: "Estimated Monthly Payment (36 Month Lease)"
            }
        },
        wizard: {
            steps: {
                zero: {
                    title: "Create Account",
                    message1: "Create a Store Account",
                    message2: "You must first create a store account. Enter the required information in the form below and click Next. By creating an account, all the items in your shopping cart will be saved."
                },
                one: {
                    title: "Billing Address",
                    sameAsShipping: "Ship to the same address"
                },
                two: {
                    title: "Shipping Address"
                },
                three: {
                    title: "Shipping Method"
                },
                four: {
                    title: "Payment Method",
                    message: "Whether you purchase in full now or you choose to lease, Velocitor requires a form of payment on file for monthly recurring charges. You can change this payment method at any time after the initial purchase by contacting the Velocitor Support Desk.",
                    agreement: "By checking the appropriate box or boxes below and proceeding with the purchasing or leasing of the items in my cart, I acknowledge, agree, and consent to the following:",
                    agreementPdfName: "Velocitor's Software Support and Depot Services Agreement",
                    productAgreementPdfName: "V-Track-VEDR Services Subscription Agreement",
                    rentalAgreementPdfName: "Rental Services Agreement"
                }
            }
        }
    },
    orderConfirmation: {
        title: "Order Confirmation",
        printOrder: "Print Order",
        invoiceCredentials: {
            billing: {
                title: "Billing Information"
            },
            shipping: {
                title: "Shipping Information",
                shippingMethod: "Shipping Method"
            },
            payment: {
                paymentMethod: "Payment Method",
                referenceNumber: "Reference Number"
            }
        },
        invoiceSummary: {
            orderNumber: "Order No",
            orderDate: "Order Date",
            orderTotal: "Order Total"
        },
        items: {
            header: {
                description: "Description",
                price: "Price",
                quantity: "Quantity",
                total: "Total",
                recurring: "Recurring Monthly Items"
            },
            footer: {
                subTotal: "Sub Total",
                shipping: "Shipping",
                fee: "CC Processing Fee",
                taxes: "Taxes",
                taxStatement: "Applicable taxes will be charged upon invoice",
                total: "Total",
                recurring: "Monthly Charge"
            }
        }
    },
    footer: {
        services: "Services",
        support: "Support",
        buyingGuide: "Buying Guide"
    },
    guestAlert: {
        desc1: "To save items added to your cart please",
        desc2: "create an account"
    },
    account: {
        firstName: "First Name",
        lastName: "Last Name",
        company: "Company",
        email: "Email (read-only)",
        phoneNumber: "Phone Number",
        password: "Password",
        confirmPassword: "Confirm Password",
        station: "Station",
        contractNumber: "Contract Number",
        employeeId: "FedEx Ground ID",
        purchaseEligibilityDate: "Purchase Eligibility Date",
        onTheRoadEligibilityDate: "On The Road Eligibility Date"
    },
    profile: {
        info: {
            title: "Customer Info",
            save: "Save Profile",
            success: "Your profile has been saved"
        },
        addresses: {
            title: "Addresses"
        },
        orders: {
            title: "Orders",
            details: "Details",
            orderStatus: "Order Status",
            orderNumber: "Order Number",
            orderDate: "Order Date",
            orderTotal: "Order Total",
            orderRecurringTotal: "Order Recurring Charges"
        },
        changePassword: {
            title: "Change Password",
            oldPassword: "Old Password",
            newPassword: "New Password",
            confirmPassword: "Confirm Password",
            save: "Change Password"
        }
    },
    address: {
        add: "Add Address",
        edit: "Edit Address",
        address1: "Address 1",
        address2: "Address 2",
        city: "City",
        state: "State",
        country: "Country",
        postalCode: "Postal Code"
    },
    bankAccount: {
        title: "Bank Draft",
        routingNumber: "Routing Number",
        accountNumber: "Account Number",
        name: "Name On Account",
        type: "Account Type",
        typeOptions: {
            checking: "Checking",
            savings: "Savings"
        }
    },
    creditCard: {
        title: "Credit/Debit Card",
        cardNumber: "Card Number",
        code: "Card Code",
        expMonth: "Expiration Month",
        expYear: "Expiration Year",
        name: "Cardholder Name",
        type: "Card Type"
    },
    lease: {
        title: "Lease"
    },
    support: {
        title: "Contact Sales Support",
        options: {
            title: "Sales Support Options"
        },
        chat: "Chat Live with a Velocitor Sales Agent",
        phone: "Contact a Velocitor Sales Agent Via Phone",
        email: "Email the Velocitor Sales Desk for assistance"
    },
    modals: {
        alreadyApproved: {
            cartReady: {
                title: "My Shopping Cart Is Ready...",
                description: "Click \"Go to Cart\" below, navigate to the bottom of the cart, and select the Lease Option. Enter your Approval Code when prompted and follow the instructions on-screen for completing your purchase.",
                btn: "Go To Cart"
            },
            continueShopping: {
                title: "I haven't Built My Cart yet...",
                description: "Click \"Start Shopping\" below to return to the Home Page to browse the various options on our store. Add items to your cart as needed. Once you are done shopping, open your cart, navigate to the bottom of the page, and select the Lease Option. Enter your Approval Code when prompted and follow the instructions on-screen for completing your purchase.",
                btn: "Start Shopping"
            }
        },
        eligibility: {
            title: "Thank you for visiting the Velocitor Store.",
            station: "Eligible Station",
            purchaseEligibility: "Purchase Eligibility",
            onTheRoadEligibility: "Go Live Eligibility",
            desc1: "Fulfill your FedEx Ground contracting standards and revolutionize the way you do business.",
            desc21: "Velocitor Solutions is the",
            desc22: "only one-stop shop",
            desc23: "for FedEx Ground Service Providers.",
            list: {
                starV: "FedEx Approved STAR V Vendor",
                vedr: "FedEx Approved VEDR Vendor",
                telematics: "FedEx Approved Telematics Vendor"
            },
            dontShow: "Do not show this again",
            continueShopping: "Continue Shopping"
        },
        lease: {
            approvalCode: {
                title1: "Have an Approval Code?",
                title2: "Enter Your Lease Approval Code",
                approvalCode: "Lease Approval Code",
                btn: "Submit",
                desc1: "Even though you have chosen to lease some or all of the eligible items on your order, Velocitor requires the entry of billing, shipping and payment information to correctly process your order once approved by the leasing company and for the monthly recurring charges. You can change this information at any time after the initial purchase by contacting the Velocitor Support Desk.",
                desc2: "If you have already applied for a lease and have received an Approval Code, enter that code in the box above and click the Submit button to process your order."
            },
            leaseApplication: {
                title: "Apply for a Lease",
                step: "Step %{number}",
                steps: {
                    one: {
                        description: "Create a Store Account (If not already a customer)"
                    },
                    two: {
                        description: "Complete The Leasing Application"
                    }
                },
                btn: "Get Started"
            }
        },
        wizardInProgress: {
            title: "Your cart changes will be lost. Would you like to continue?",
            yes: "Yes",
            no: "No"
        },
        chatSoon: {
            title: "Live Chat feature coming soon"
        }
    },
    attributes: {
        homeOfficeChargingAccessories: "Home/Office Charging Accessories",
        vehicleChargingAccessories: "Vehicle Charging Accessories",
        holsters: "Holsters",
        miscellaneousAccessories: "Miscellaneous Accessories",
        rogersDataPlans: "Rogers Data Plans"
    },
    misc: {
        month: "Month",
        learnMore: "Learn More",
        select: "Select",
        chooseDevice: "Choose Device",
        selectForKit: "Select for Kit",
        details: "Details",
        partNumber: "Part Number",
        buyNow: "Buy Now",
        addToCart: "Add To Cart",
        subTotal: "Subtotal",
        shipping: "Estimated Shipping",
        newAddress: "New Address",
        device: "Device",
        specifications: "%{name} Specifications",
        shop: "Shop",
        chat: "Chat",
        liveChat: "Live Chat",
        phone: "Phone",
        email: "Email",
        step: "Step",
        previous: "Previous",
        next: "Next",
        finish: "Finish",
        complete: "Complete",
        edit: "Edit",
        delete: "Delete",
        hours: "Hours",
        salesHours: "Monday-Saturday 7am-10pm",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        availability: "Availability"
    },
    abbreviations: {
        quantity: "qty"
    },
    alerts: {
        quantity: "Enter a quantity",
        addedToCart: "(%{quantity}) %{name} was added to the cart",
        paymentError: "There was an error processing the payment. Please contact support for assistance.",
        genericError: "There was an error. Contact your administrator for assistance."
    },
    validation: {
        login: {
            contractNumber: {
                required: "Enter your Contract Number"
            },
            employeeId: {
                required: "Enter your FedEx Ground ID"
            },
            username: {
                required: "Enter your email address"
            },
            password: {
                required: "Enter your password"
            }
        },
        passwordRecovery: {
            email: {
                required: "Enter your Email Address",
                email: "Invalid Email address"
            }
        },
        passwordReset: {
            password: {
                required: "Enter your Password"
            },
            confirmPassword: {
                required: "Confirm your Password",
                match: "Confirm password doesn't match"
            }
        },
        account: {
            firstName: {
                required: "Enter your First Name"
            },
            lastName: {
                required: "Enter your Last Name"
            },
            company: {
                required: "Enter your Company Name",
                exists: "Company name already exists. Please login using your credentials or contact Sales Support at sales@velocitor.com for assistance."
            },
            email: {
                required: "Enter your Email Address",
                email: "Invalid Email address"
            },
            phoneNumber: {
                required: "Enter your Phone Number",
                number: "Invalid Phone Number, must be 10 digits"
            },
            password: {
                required: "Enter your Password"
            },
            confirmPassword: {
                required: "Confirm your Password",
                match: "Confirm password doesn't match"
            }
        },
        address: {
            address1: {
                required: "Enter your Address"
            },
            address2: {
                noPoundSign: "This field cannot contain the '#' symbol"
            },
            city: {
                required: "Enter your City Name"
            },
            state: {
                required: "Choose your State"
            },
            country: {
                required: "Choose your Country"
            },
            postalCode: {
                required: "Enter your Zip / Postal code"
            }
        },
        bankAccount: {
            routingNumber: {
                required: "Enter your Routing Number"
            },
            accountNumber: {
                required: "Enter your Account Number"
            },
            name: {
                required: "Enter Account Name"
            },
            type: {
                required: "Choose an Account Type"
            },
            terms: {
                required: "You must check the Services Agreement Acknowledgement Checkbox before Proceeding"
            }
        },
        creditCard: {
            cardNumber: {
                required: "Enter your Card Number"
            },
            code: {
                required: "Enter your Card Code"
            },
            expMonth: {
                required: "Choose an Expiration Month"
            },
            expYear: {
                required: "Choose an Expiration Year"
            },
            name: {
                required: "Enter Cardholder Name as it appears on card"
            }
        },
        profile: {
            changePassword: {
                oldPassword: {
                    required: "Enter your Old Password"
                },
                newPassword: {
                    required: "Enter your New Password"
                },
                confirmNewPassword: {
                    required: "Confirm your New Password",
                    match: "Confirm password doesn't match"
                }
            }
        }
    },
    locale: {
        date: {
            short: "M/D/YYYY",
            long1: "MMM D, YYYY",
            long2: "MMMM Do, YYYY"
        }
    }
};